<template>
  <div class="min-h-screen bg-base-100">
    <div class="container mx-auto px-4 py-12">
      <div class="max-w-4xl mx-auto">
        <h1 class="text-4xl font-bold text-base-content mb-8">Aviso Legal</h1>

        <div class="prose prose-lg max-w-none">
          <p class="text-lg text-base-content/80 mb-8">
            En virtud del cumplimiento de la
            <a
              href="https://www.boe.es/buscar/act.php?id=BOE-A-2002-13758"
              class="text-primary hover:underline"
              target="_blank"
            >
              Ley 34/2002, de 11 de Julio, de Servicios de la Sociedad de la
              Información y de Comercio Electrónico </a
            >, le informamos:
          </p>

          <section class="mb-8">
            <h2 class="text-2xl font-semibold text-base-content mb-4">
              1. OBJETO
            </h2>
            <p class="text-base-content/80 mb-4">
              <strong>Art. 10 LSSI:</strong>
            </p>
            <p class="text-base-content/80 mb-4">
              Este dominio en internet es de titularidad de DESERTANDO CLUB DE
              AVENTURAS, S.L. (en adelante DESERTANDO), con Domicilio Social en
              Calle Arturo Soria, 333 – 28033 Madrid y CIF B87565966. La empresa
              consta inscrita en el Registro Mercantil de Madrid, Tomo 34711,
              Folio 161, Inscripción 1ª, Hoja nº M-624318.
            </p>
            <div class="bg-base-200 p-6 rounded-lg mb-4">
              <p class="text-base-content/80 mb-2">
                <strong>Datos de contacto:</strong>
              </p>
              <p class="text-base-content/80 mb-2">
                Teléfono: (+34) 608 76 29 62 / (+34) 620 50 17 61
              </p>
              <p class="text-base-content/80">
                Correo electrónico:
                <a
                  href="mailto:info@soleando.eu"
                  class="text-primary hover:underline"
                  >info@soleando.eu</a
                >
              </p>
            </div>
            <p class="text-base-content/80 mb-4">
              Este Aviso Legal regula la utilización del dominio.
            </p>
            <p class="text-base-content/80">
              La utilización de este sitio web implica la aceptación por parte
              del usuario de las condiciones de uso incluidas en este Aviso
              Legal, así como de las políticas sobre
              <NuxtLink to="/privacy" class="text-primary hover:underline"
                >'Política de Privacidad y Protección de Datos'</NuxtLink
              >
              y
              <NuxtLink to="/cookies" class="text-primary hover:underline"
                >'Política de Cookies'</NuxtLink
              >, incluidas en el mismo sitio web.
            </p>
          </section>

          <section class="mb-8">
            <h2 class="text-2xl font-semibold text-base-content mb-4">
              2. CONDICIONES DE UTILIZACIÓN
            </h2>
            <p class="text-base-content/80 mb-4">
              El usuario se compromete, en los apartados en que sea necesario
              que se registre para poder acceder a los mismos, a facilitar datos
              veraces y exactos. El usuario se compromete a mantener
              actualizados los datos personales que pudieran ser proporcionados
              al titular del dominio, por lo tanto, único responsable de las
              falsedades o inexactitudes que realice.
            </p>
            <p class="text-base-content/80 mb-4">
              Se informa que, en caso de ser menor de edad, deberá obtener el
              permiso de sus tutores o representantes legales para poder acceder
              a los servicios prestados. DESERTANDO no se responsabiliza en el
              caso de que los datos sean inexactos o falsos.
            </p>
            <p class="text-base-content/80 mb-4">
              Este sitio web solo puede ser utilizado con propósitos legales,
              por tanto, el usuario se obliga a hacer un uso lícito y honrado
              del mismo y conforme a las presentes Condiciones Generales de Uso,
              a no utilizar los servicios del sitio web para la realización de
              actividades contrarias a las legislación española, ni europea, a
              la moral y al orden público asumiendo, por parte del usuario,
              todas las responsabilidades de daños y perjuicios frente al
              titular del dominio o terceros que pudieran derivarse de prácticas
              ilegales o no permitidas.
            </p>

            <h3 class="text-xl font-semibold text-base-content mb-3">
              A título enunciativo y no limitativo:
            </h3>
            <ul class="list-disc pl-6 text-base-content/80 mb-4">
              <li class="mb-2">
                Realizar sin previo consentimiento por parte del titular del
                dominio cualquier manipulación o alteración de esta página, no
                asumiendo el titular del dominio ninguna responsabilidad que
                pudiera derivarse de dicha manipulación o alteración por
                terceros.
              </li>
              <li class="mb-2">
                Realizar cualquier acto que pueda dañar, inutilizar, sobrecargar
                o deteriorar el sitio web y los servicios y/o impedir el normal
                uso y utilización por parte de los Usuarios.
              </li>
              <li class="mb-2">
                Introducir y/o utilizar programas de ordenador, datos, archivos
                defectuosos, virus, código malicioso, equipos informáticos o de
                telecomunicaciones o cualquier otro, independientemente de su
                naturaleza, que pueda causar daños en el sitio web.
              </li>
              <li class="mb-2">
                Violar los derechos de terceros a la intimidad, la propia
                imagen, la protección de datos al secreto en las comunicaciones,
                a la propiedad intelectual e industrial.
              </li>
              <li class="mb-2">
                Utilizar identidades falsas, suplantar la identidad de otros en
                la utilización del sitio web o en la utilización de cualquiera
                de los servicios.
              </li>
              <li>
                Reproducir, distribuir, modificar o copiar el contenido de esta
                página, salvo que de disponga de la autorización del titular del
                dominio o esté legalmente autorizado.
              </li>
            </ul>
          </section>

          <section class="mb-8">
            <h2 class="text-2xl font-semibold text-base-content mb-4">
              3. RESPONSABILIDAD Y EXENCIÓN
            </h2>
            <p class="text-base-content/80 mb-4">
              DESERTANDO no responde de los enlaces (links) a otras páginas de
              Internet de terceros y su existencia no implica que DESERTANDO
              apruebe o acepte sus contenidos y servicios. Estas otras páginas
              web no están controladas por DESERTANDO ni cubiertas por la
              presente
              <NuxtLink to="/privacy" class="text-primary hover:underline"
                >Política de Privacidad</NuxtLink
              >.
            </p>
            <p class="text-base-content/80 mb-4">
              Con carácter general, el titular del dominio excluye su
              responsabilidad por los daños y perjuicios de cualquier naturaleza
              e índole que pudieran derivarse del uso del sitio web, así como a
              los daños y perjuicios derivados de la infracción de los derechos
              de propiedad Intelectual e Industrial por parte de los usuarios
              y/o la falta de veracidad, exactitud y actualidad de los
              contenidos.
            </p>
            <p class="text-base-content/80">
              El titular del dominio no será responsable por los daños y
              perjuicios causados por la presencia de virus o cualquier otro
              software lesivo que pueda producir alteraciones en el sistema
              informático del usuario.
            </p>
          </section>

          <section class="mb-8">
            <h2 class="text-2xl font-semibold text-base-content mb-4">
              4. PROPIEDAD INTELECTUAL E INDUSTRIAL
            </h2>
            <p class="text-base-content/80 mb-4">
              El sitio web, incluyendo a título enunciativo pero no limitativo
              su programación, diseños, logotipos, texto y/o gráficos son
              propiedad del prestador o en su caso dispone de licencia o
              autorización expresa por parte de los autores.
            </p>
            <p class="text-base-content/80 mb-4">
              Independientemente de la finalidad para la que fueran destinados,
              la reproducción total o parcial, uso, explotación, distribución y
              comercialización, requiere en todo caso de la autorización escrita
              previa por parte del titular del dominio.
            </p>
            <p class="text-base-content/80">
              El usuario se compromete a no realizar ningún acto en contra de
              los derechos de propiedad intelectual o industrial del autor.
            </p>
          </section>

          <section class="mb-8">
            <h2 class="text-2xl font-semibold text-base-content mb-4">
              5. PROTECCIÓN DE DATOS Y USO DE COOKIES
            </h2>
            <p class="text-base-content/80">
              Puede consultar nuestra política sobre protección de datos de
              carácter personal y uso de cookies en los siguientes apartados:
            </p>
            <div class="flex flex-wrap gap-4 mt-4">
              <NuxtLink to="/privacy" class="btn btn-primary btn-outline">
                Política de Privacidad y Protección de Datos
              </NuxtLink>
              <NuxtLink to="/cookies" class="btn btn-primary btn-outline">
                Política de Cookies
              </NuxtLink>
            </div>
          </section>

          <section class="mb-8">
            <h2 class="text-2xl font-semibold text-base-content mb-4">
              6. LEGISLACIÓN APLICABLE
            </h2>
            <p class="text-base-content/80">
              Las presentes Condiciones se regirán en todo momento por lo
              dispuesto en la legislación española y europea.
            </p>
          </section>

          <section class="mb-8">
            <h2 class="text-2xl font-semibold text-base-content mb-4">
              INFORMACIÓN DE LA EMPRESA
            </h2>
            <div class="bg-base-200 p-6 rounded-lg">
              <p class="text-base-content/80 mb-2">
                <strong>DESERTANDO CLUB DE AVENTURAS, S.L.</strong>
              </p>
              <p class="text-base-content/80 mb-2">
                Domicilio Social: C/ Arturo Soria, 333 – 28033 Madrid, España
              </p>
              <p class="text-base-content/80 mb-2">CIF: B87565966</p>
              <p class="text-base-content/80 mb-2">CICMA: 3627</p>
              <p class="text-base-content/80 mb-2">
                Registro Mercantil: Madrid, Tomo 34711, Folio 161, Inscripción
                1ª, Hoja nº M-624318
              </p>
              <p class="text-base-content/80 mb-2">
                Teléfonos: (+34) 608 76 29 62 / (+34) 620 50 17 61
              </p>
              <p class="text-base-content/80">
                Email:
                <a
                  href="mailto:info@soleando.eu"
                  class="text-primary hover:underline"
                  >info@soleando.eu</a
                >
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
definePageMeta({
  layout: "default",
});

useSeoMeta({
  title: "Aviso Legal - Soleando",
  description:
    "Aviso legal de Soleando. Información legal sobre el uso del sitio web y condiciones de utilización.",
});
</script>

<style scoped></style>
